import React, { useEffect, useRef } from 'react';
import AixueFooter from '@/components/AixueFooter/index';
import styles from './index.module.scss';
import Screen1 from './Screen1';
import Screen2 from './Screen2';
import Screen3 from './Screen3';
import Screen4 from './Screen4';

export default function AixueAbout() {
  return (
    <div className={`${styles.container} aixue-about-scroll`}>
      <Screen1 />
      <Screen2 />
      <Screen3 />
      <Screen4 />
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
